export const name = 'privateWixCodeSdk' as const
export const namespace = 'private' as const
